import script from "./FloatButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatButton.vue?vue&type=script&setup=true&lang=js"

import "./FloatButton.vue?vue&type=style&index=0&id=f3c11ef0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3c11ef0"]])

export default __exports__